import type { ReactNode } from "react"
import styles from "@/styles/components/Pill.module.css"

/*
 * One small status or count chip.
 *
 * The prototype uses this shape for a dozen different facts — a live session, a
 * card count, "Top pain point", "Picking", a cap warning — and they were all
 * separate page-local classes. Collapsing them here is what keeps a count on the
 * board and a count on the customer list the same object.
 *
 * `tone` is meaning, not colour: `warning` is a cap exceeded, `done` is a person
 * finished. The stylesheet decides what those look like.
 */

interface PillProps {
  children: ReactNode
  tone?: "neutral" | "action" | "warning" | "done"
  /** A leading dot. With `pulse`, the prototype's live indicator. */
  dot?: boolean
  pulse?: boolean
  title?: string
}

export default function Pill({ children, tone = "neutral", dot, pulse, title }: PillProps) {
  return (
    <span className={`${styles.pill} ${styles[tone]}`} title={title}>
      {dot ? (
        <span className={pulse ? `${styles.dot} ${styles.pulse}` : styles.dot} aria-hidden="true" />
      ) : null}
      {children}
    </span>
  )
}
